// NOTE: Dependencies: jQuery, Defiant

(function($) {
	$.fn.lmSearchResults = function(options) {

		const $context = $(this);

		// check is dom element is defined
		if (!this.length) {
			return false;
		}

		// Default settings are set here.
		var settings = $.extend({
			totalCount: 0,
			$resultsCount: $('#resultsCount'),
			count: []
		}, options);

		// These are all the methods available for the plugin.
		var methods = {};

		methods.setCurrentSettings = function() {
			var currentSettings = $context.data();

			if (!$.isEmptyObject(currentSettings)) {
				$context.data($.extend({}, settings, currentSettings));
			} else {
				$context.data(settings);
			}

			// Initialize item.
			$context.data('initialized', true);
		};

		// Set Results
		methods.setResultTotal = function() {
			$context.each(function() {
				var count = parseInt($(this).attr('data-count'));
				settings.count.push(count)
			})

			$.each(settings.count, function() {
				settings.totalCount = settings.totalCount + parseInt(this);
			});

			settings.$resultsCount.text(settings.totalCount);
		};

		// On load function.
		methods.initContext = function() {

			methods.setCurrentSettings();
			methods.setResultTotal();
		};

		// Filter each function.
		methods.filterEach = function() {
			return !$(this).data('initialized');
		};

		// Methods to run inside loop.

		methods.initContext($(this));
	};

	if ($('.results-count').length) {
		$('.results-count').lmSearchResults();
	}

}(jQuery));
